<template>
  <div class="d-flex align-center flex-wrap px-4 pb-2">

    <!-- Facette Version (checklist + recherche) -->
    <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" outlined small class="mr-2 mb-1"
          :color="value.versions.length > 0 ? 'primary' : ''">
          {{ checklistLabel('versions', 'Version') }}
          <v-icon small right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-card width="280">
        <v-text-field v-model="versionSearch" placeholder="Rechercher une version..."
          dense hide-details clearable class="px-3 pt-2 pb-1 version-search" />
        <v-list dense style="max-height: 280px; overflow-y: auto;">
          <v-list-item v-for="v in filteredVersions" :key="v" @click="toggle('versions', v)">
            <v-list-item-action class="my-0 mr-2">
              <v-icon small :color="value.versions.includes(v) ? 'primary' : ''">
                {{ value.versions.includes(v) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ v }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider />
        <v-card-actions class="py-1">
          <v-btn text x-small color="error" :disabled="value.versions.length === 0"
            @click="set('versions', [])">Effacer</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- Facette Type du dernier job (checklist) -->
    <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" outlined small class="mr-2 mb-1"
          :color="value.jobTypes.length > 0 ? 'primary' : ''">
          {{ checklistLabel('jobTypes', 'Type de job') }}
          <v-icon small right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-card width="260">
        <v-list dense style="max-height: 320px; overflow-y: auto;">
          <v-list-item v-for="t in options.jobTypes" :key="t" @click="toggle('jobTypes', t)">
            <v-list-item-action class="my-0 mr-2">
              <v-icon small :color="value.jobTypes.includes(t) ? 'primary' : ''">
                {{ value.jobTypes.includes(t) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ t }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider />
        <v-card-actions class="py-1">
          <v-btn text x-small color="error" :disabled="value.jobTypes.length === 0"
            @click="set('jobTypes', [])">Effacer</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- Facette État du dernier job (checklist) -->
    <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" outlined small class="mr-2 mb-1"
          :color="value.states.length > 0 ? 'primary' : ''">
          {{ checklistLabel('states', 'État') }}
          <v-icon small right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-card width="220">
        <v-list dense>
          <v-list-item v-for="s in options.states" :key="s" @click="toggle('states', s)">
            <v-list-item-action class="my-0 mr-2">
              <v-icon small :color="value.states.includes(s) ? 'primary' : ''">
                {{ value.states.includes(s) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ s }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider />
        <v-card-actions class="py-1">
          <v-btn text x-small color="error" :disabled="value.states.length === 0"
            @click="set('states', [])">Effacer</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- Facette Date du dernier job (presets, choix unique) -->
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" outlined small class="mr-2 mb-1"
          :color="value.jobDate ? 'primary' : ''">
          {{ value.jobDate ? 'Date du job : ' + value.jobDate.label : 'Date du job' }}
          <v-icon small right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item v-for="p in datePresets" :key="p.label"
          :input-value="value.jobDate && value.jobDate.label === p.label"
          @click="set('jobDate', p)">
          <v-list-item-title>{{ p.label }}</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="set('jobDate', null)">
          <v-list-item-title class="error--text">Effacer</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Facette Dernier ping (presets, choix unique) -->
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" outlined small class="mr-2 mb-1"
          :color="value.lastPing ? 'primary' : ''">
          {{ value.lastPing ? 'Ping : ' + value.lastPing.label : 'Ping' }}
          <v-icon small right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item v-for="p in datePresets" :key="p.label"
          :input-value="value.lastPing && value.lastPing.label === p.label"
          @click="set('lastPing', p)">
          <v-list-item-title>{{ p.label }}</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="set('lastPing', null)">
          <v-list-item-title class="error--text">Effacer</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Facette Warning veille (choix unique) -->
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" outlined small class="mr-2 mb-1"
          :color="value.warning ? 'primary' : ''">
          {{ value.warning ? 'Warning : ' + (value.warning === 'shown' ? 'affiché' : 'masqué') : 'Warning' }}
          <v-icon small right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item :input-value="value.warning === 'shown'" @click="set('warning', 'shown')">
          <v-list-item-title>Affiché</v-list-item-title>
        </v-list-item>
        <v-list-item :input-value="value.warning === 'hidden'" @click="set('warning', 'hidden')">
          <v-list-item-title>Masqué</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="set('warning', null)">
          <v-list-item-title class="error--text">Effacer</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-spacer />

    <!-- Actions contextuelles injectées par le parent (ex : tout sélectionner) -->
    <slot name="actions"></slot>

    <v-btn text x-small color="error" class="mb-1" v-if="hasActiveFilters" @click="resetAll">
      <v-icon x-small left>mdi-close</v-icon>
      Réinitialiser les filtres
    </v-btn>
  </div>
</template>

<script>
/**
 * Barre de facettes pour filtrer la table des kiosks.
 * Un bouton par champ ; les valeurs proposées viennent des données réelles (props.options).
 * v-model : { versions: [], jobTypes: [], states: [], jobDate: null, lastPing: null, warning: null }
 * Les facettes se cumulent en ET ; le parent applique le filtrage.
 */
const DATE_PRESETS = [
  { label: '24 dernières heures', mode: 'within', days: 1 },
  { label: '3 derniers jours', mode: 'within', days: 3 },
  { label: '7 derniers jours', mode: 'within', days: 7 },
  { label: '30 derniers jours', mode: 'within', days: 30 },
  { label: 'Plus vieux que 7 jours', mode: 'older', days: 7 },
  { label: 'Plus vieux que 30 jours', mode: 'older', days: 30 }
];

export default {
  name: 'KioskFilterBar',
  props: {
    value: { type: Object, required: true },
    // { versions: [...], jobTypes: [...], states: [...] } : valeurs distinctes du parc
    options: { type: Object, required: true }
  },
  data() {
    return {
      versionSearch: '',
      datePresets: DATE_PRESETS
    };
  },
  computed: {
    filteredVersions() {
      if (!this.versionSearch) return this.options.versions;
      const s = this.versionSearch.toLowerCase();
      return this.options.versions.filter(v => String(v).toLowerCase().includes(s));
    },
    hasActiveFilters() {
      const v = this.value;
      return v.versions.length > 0 || v.jobTypes.length > 0 || v.states.length > 0
        || v.jobDate !== null || v.lastPing !== null || v.warning !== null;
    }
  },
  methods: {
    set(key, val) {
      this.$emit('input', { ...this.value, [key]: val });
    },
    toggle(key, item) {
      const arr = this.value[key];
      const next = arr.includes(item) ? arr.filter(x => x !== item) : [...arr, item];
      this.set(key, next);
    },
    checklistLabel(key, base) {
      const arr = this.value[key];
      if (arr.length === 0) return base;
      if (arr.length === 1) return base + ' : ' + arr[0];
      return base + ' : ' + arr[0] + ' +' + (arr.length - 1);
    },
    resetAll() {
      this.$emit('input', {
        versions: [], jobTypes: [], states: [],
        jobDate: null, lastPing: null, warning: null
      });
    }
  }
};
</script>

<style scoped>
/* Placeholder du champ de recherche de version : blanc, comme le texte des boutons */
.version-search ::v-deep input::placeholder {
  color: #ffffff;
  opacity: 0.8;
}
</style>
